import gql from 'graphql-tag';
import collegeEventFilterFragment from './collegeEventFilterFragment';
import collegeEventLocationFragment from '../../CollegeEventLocation/graphql/collegeEventLocationFragment';

export default gql`
  mutation updateCollegeEvent($input: updateCollegeEventInput!) {
    updateCollegeEvent(input: $input) {
      collegeEvent {
        id
        version
        institution
        name
        eventDateTime
        eventEndDateTime
        timezone
        startTime
        endTime
        eventDescription
        registrationUrl
        registrationDeadline
        registrationDeadlineTime
        displayIn {
          naviancestudent
          camino
        }
        status
        visible
        virtual
        collegeEventFilter {
          ...CollegeEventFilter
        }
        collegeEventLocation {
          ...CollegeEventLocation
        }
      }
    }
  }
  ${collegeEventFilterFragment}
  ${collegeEventLocationFragment}
`;
